import {
  GET_TASKLISTDETAIL,
  GET_TASKLISTDETAIL_SUCCESS,
  GET_TASKLISTDETAIL_FAIL,
  DELETE_TASKLISTDETAIL,
  DELETE_TASKLISTDETAIL_SUCCESS,
  DELETE_TASKLISTDETAIL_FAIL,
  UPDATE_TASKLISTDETAIL,
  UPDATE_TASKLISTDETAIL_SUCCESS,
  UPDATE_TASKLISTDETAIL_FAIL,
  ADD_NEW_TASKLISTDETAIL,
  ADD_TASKLISTDETAIL_SUCCESS,
  ADD_TASKLISTDETAIL_FAIL,
  TASKLISTDETAIL_LOADING,
  TASKLISTDETAIL_RESET,
} from "./actionType";

export const resetTaskListDetailState = (actionType) => ({
  type: TASKLISTDETAIL_RESET,
  payload: { actionType },
});

export const getTaskListDetailSuccess = (actionType, data) => ({
  type: GET_TASKLISTDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getTaskListDetailFail = (actionType, error) => ({
  type: GET_TASKLISTDETAIL_FAIL,
  payload: { actionType, error },
});

export const getTaskListDetail = data => ({
  type: GET_TASKLISTDETAIL,
  payload: data,
});

export const getTaskListDetailLoading = () => ({
  type: TASKLISTDETAIL_LOADING
});

export const deleteTaskListDetail = data => ({
  type: DELETE_TASKLISTDETAIL,
  payload: data,
});

export const deleteTaskListDetailSuccess = data => ({
  type: DELETE_TASKLISTDETAIL_SUCCESS,
  payload: data,
});

export const deleteTaskListDetailFail = error => ({
  type: DELETE_TASKLISTDETAIL_FAIL,
  payload: error,
});

export const updateTaskListDetail = data => ({
  type: UPDATE_TASKLISTDETAIL,
  payload: data,
});

export const updateTaskListDetailFail = error => ({
  type: UPDATE_TASKLISTDETAIL_FAIL,
  payload: error,
});

export const updateTaskListDetailSuccess = data => ({
  type: UPDATE_TASKLISTDETAIL_SUCCESS,
  payload: data,
});

export const addNewTaskListDetail = data => ({
  type: ADD_NEW_TASKLISTDETAIL,
  payload: data,
});

export const addTaskListDetailSuccess = data => ({
  type: ADD_TASKLISTDETAIL_SUCCESS,
  payload: data,
});

export const addTaskListDetailFail = error => ({
  type: ADD_TASKLISTDETAIL_FAIL,
  payload: error,
});